// import axios from "axios";
import kalapostAPI, { getErrorType } from './httpService';

export const verifyTokenService = async () => {
   try {
      return await kalapostAPI.post('sbonjure');
   } catch (error) {
      return getErrorType(error);
   }
};

export const userCodeService = async (phoneNumber, token) => {
   try {
      return await kalapostAPI.post(
         'sendcode',
         { phoneNumber },
         { headers: { 'g-recaptcha-response': token } }
      );
   } catch (error) {
      return getErrorType(error);
   }
};

export const userRegisteredService = async (phoneNumber, token) => {
   try {
      return await kalapostAPI.post(
         'uniquephonenumber',
         { phoneNumber },
         { headers: { 'g-recaptcha-response': token } }
      );
   } catch (error) {
      return getErrorType(error);
   }
};

export const userLoginStartService = async (phoneNumber, password, token) => {
   try {
      return await kalapostAPI.post(
         'login',
         { phoneNumber, password },
         { headers: { 'g-recaptcha-response': token } }
      );
   } catch (error) {
      return getErrorType(error);
   }
};

export const userCodeValid = async (phoneNumber, code, token, tokenCode) => {
   try {
      return await kalapostAPI.post(
         'validCode ',
         { phoneNumber, code, tokenCode },
         { headers: { 'g-recaptcha-response': token } }
      );
   } catch (error) {
      return getErrorType(error);
   }
};

export const userRegister = async (
   phoneNumber,
   address,
   postalCode,
   nationalId,
   cityId,
   password,
   fullName,
   tokenCode,
   codeMessage,
   legal,
   token
) => {
   try {
      return await kalapostAPI.post(
         'register',
         {
            phoneNumber,
            address,
            postalCode,
            nationalId,
            cityId,
            password,
            fullName,
            tokenCode,
            code: codeMessage,
            legal,
         },
         { headers: { 'g-recaptcha-response': token } }
      );
   } catch (error) {
      return getErrorType(error);
   }
};

export const postPriceService = async (
   serviceType,
   deliveryType,
   destination,
   packages,
   packing,
   assurance,
   pickup,
   origin,
   serviceFee,
   deliveryTypeId,
   serviceTypeId,
   token
) => {
   try {
      return await kalapostAPI.post(
         'price',
         {
            serviceType,
            deliveryType,
            destination,
            packages,
            packing,
            assurance,
            pickup,
            origin,
            serviceFee,
            deliveryTypeId,
            serviceTypeId,
         },
         { headers: { 'g-recaptcha-response': token } }
      );
   } catch (error) {
      return getErrorType(error);
   }
};

export const postOrderService = async (
   originLat,
   originLng,
   serviceTypeId,
   deliveryTypeId,
   destination,
   packages,
   packing,
   assurance,
   fullName,
   phoneNumber,
   address,
   postalCode,
   paymentTimeId,
   paymentTypeId,
   serviceFee,
   price,
   origin,
   pickup,
   nationalId,
   token
) => {
   const tmp = { ...assurance, value: Number(assurance.value) };
   try {
      return await kalapostAPI.post(
         'service',
         {
            originLat,
            originLng,
            serviceTypeId: Number(serviceTypeId),
            deliveryTypeId: Number(deliveryTypeId),
            destination,
            packages,
            packing,
            assurance: tmp,
            fullName,
            phoneNumber,
            address,
            postalCode,
            paymentTimeId: Number(paymentTimeId),
            paymentTypeId: Number(paymentTypeId),
            serviceFee,
            price,
            origin,
            paymentStatId: 1,
            pickup,
            nationalId,
         },
         { headers: { 'g-recaptcha-response': token } }
      );
   } catch (error) {
      return getErrorType(error);
   }
};

export const getUserRequests = async () => {
   try {
      return await kalapostAPI.get('requests');
   } catch (error) {
      return getErrorType(error);
   }
};

export const getUserRequest = async (requestId) => {
   try {
      return await kalapostAPI.get('request', {
         params: { requestId },
      });
   } catch (error) {
      return getErrorType(error);
   }
};

export const userLogoutService = async () => {
   try {
      return await kalapostAPI.post('logout');
   } catch (error) {
      return getErrorType(error);
   }
};

export const getNationalStatusService = async (nationalId) => {
   try {
      return await kalapostAPI.post('nationalId', { nationalId });
   } catch (error) {
      return getErrorType(error);
   }
};
